import type { Specialist } from '../models/specialist';
import { usePublicSiteData } from './use-public-site-data';

interface SpecialistsState {
    specialists: readonly Specialist[];

    /** Nothing to show yet, and an answer is still coming. */
    loading: boolean;

    /** The list is current, so a `?specialist=` it does not name can be dropped. */
    settled: boolean;
}

/**
 * The consultants, present on the first render when the page carried them.
 *
 * A failure yields the list the page already had, or an empty one, rather than an error screen: the
 * rest of the page has its own content, and a section that cannot load is not rendered.
 */
export function useSpecialists(): SpecialistsState {
    const { data, settled } = usePublicSiteData();

    return {
        specialists: data.specialists,
        loading: !settled && data.specialists.length === 0,
        settled
    };
}
